const StringToEnum = (rep, enumToCheck) => {
  if (rep === void 0) {
    return void 0;
  }
  if (typeof rep === "string") {
    for (const [key, value] of Object.entries(enumToCheck)) {
      if (key.toLowerCase() === rep.toLowerCase()) {
        rep = value;
        break;
      }
    }
  }
  return rep;
};
const EnumToString = (rep, enumToCheck) => {
  for (const [key, value] of Object.entries(enumToCheck)) {
    if (value === rep) {
      return key;
    }
  }
  return void 0;
};
export {
  EnumToString,
  StringToEnum
};
//# sourceMappingURL=typehelpers.js.map
